import * as classnames from 'classnames';
import * as React from 'react';

interface CheckboxProps {
    onChange: (e) => void;
    text?: string;
    value: string;
    defaultChecked: boolean;
    disabled: boolean;
    className?: string;
    body?: JSX.Element;
}
function Checkbox(props: CheckboxProps) {
    const { onChange, text, value, defaultChecked, disabled, className } =
        props;
    return (
        <div className={`checkbox-container ${className ? className : ''}`}>
            <input
                id={`${value}-checkbox`}
                className="control-checkbox"
                type="checkbox"
                name={value}
                onChange={onChange}
                value={value}
                defaultChecked={defaultChecked}
                disabled={disabled}
                checked={defaultChecked}
            />
            {text && (
                <label
                    htmlFor={`${value}-checkbox`}
                    style={{ marginBottom: '10px', marginLeft: '5px' }}
                >
                    {text}
                </label>
            )}
        </div>
    );
}

export default Checkbox;

export function CustomCheckbox({
    text,
    value,
    className,
    onChange,
    defaultChecked,
    disabled,
    body
}: CheckboxProps) {
    return (
        <>
            <div
                className={classnames(`custom-checkbox-container`, {
                    classNames: className,
                    checked: defaultChecked,
                    disabled
                })}
            >
                <label htmlFor={`${value}-checkbox`}>
                    <input
                        id={`${value}-checkbox`}
                        className="control-checkbox"
                        type="checkbox"
                        checked={defaultChecked}
                        defaultChecked={defaultChecked}
                        onChange={onChange}
                        disabled={disabled}
                    />
                    <span className={`control-checkbox--fill`}></span>
                    {text}
                </label>
            </div>
            {body}
        </>
    );
}
